import { LuLayoutDashboard } from 'react-icons/lu'
import { MdOutlineElectricMeter } from 'react-icons/md'

const appRoutes = [
    {
        text: 'Menu',
        child: [
            {
                url: '/inspector',
                text: 'Dashboard',
                permission: 'dashboard',
                icon: <LuLayoutDashboard />,
            },
            {
                active: ['/inspector/tests'],
                url: '/inspector/tests',
                text: 'Tests',
                icon: <MdOutlineElectricMeter />,
            },
        ],
    },
]

export default appRoutes
